import React from 'react';
import PropTypes from 'prop-types';
import { Nav } from '@storybook/components-marketing';

const ALGOLIA_API_KEY = process.env.GATSBY_ALGOLIA_API_KEY;

export const Header = ({
  githubStars,
  versionString,
}) => (
  <>
    <Nav
      version={versionString}
      apiKey={ALGOLIA_API_KEY}
      activeSection="community"
      githubStarCount={githubStars}
    />
  </>
);

Header.propTypes = {
  githubStars: PropTypes.number.isRequired,
  versionString: PropTypes.string.isRequired,
};
